import { FileeeClientI18N } from '@fileee/components';

let fileeeI18n: FileeeClientI18N = new FileeeClientI18N();

export function getI18n(): FileeeClientI18N {
  return fileeeI18n;
}
